
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curriculum/savvas-myview",
      function () {
        return require("private-next-pages/curriculum/savvas-myview.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/curriculum/savvas-myview"])
      });
    }
  